module.exports = __webpack_public_path__ + "static/img/1.bb925cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhongzaisheng/detail3/1.png
// module id = IuFd
// module chunks = 19